import { Address } from '../models';
import { BikeDisableState } from '../enums/bikeDisableState';

export class DockingStationExtension {

    public static GetAddress(address: Address): string {
        let addressStr = '';
        addressStr += address.Street ? address.Street.trim() + ", " : "";
        addressStr += address.ZipCode ? address.ZipCode.trim() + ", " : "";
        addressStr += address.City ? address.City.trim() + ", " : "";
        addressStr += address.District ? address.District.trim() + ", " : "";
        addressStr += address.Country ? address.Country.trim() : "";
        return addressStr;
    }

    // Returns true if the bike's position falls within any of the given docking stations' radius (in meters).
    public static isWithinAnyStationRadius(
        bike: { Position?: { Latitude: number, Longitude: number } | null },
        stations: Array<{ Position?: { Latitude: number, Longitude: number }, Radius?: number }>
    ): boolean {
        if (!bike || !bike.Position || !stations) {
            return false;
        }

        return stations.some(station => {
            if (!station || !station.Position || station.Radius == null) {
                return false;
            }
            const distance = this.getDistanceInMeters(
                bike.Position.Latitude, bike.Position.Longitude,
                station.Position.Latitude, station.Position.Longitude
            );
            return distance <= station.Radius;
        });
    }

    // Mirrors live-map.component.ts's loadBikePositions() "show free standing bikes outside stations" toggle definition.
    public static isFreeStandingOutsideRadius(
        bike: {
            DockingStationId?: number | null,
            DisabledReason?: number | null,
            InSession?: boolean,
            Position?: { Latitude: number, Longitude: number } | null
        },
        stations: Array<{ Position?: { Latitude: number, Longitude: number }, Radius?: number }>
    ): boolean {
        if (!bike || !bike.Position || bike.DockingStationId != null) {
            return false;
        }

        const excludedDisabledReasons = [
            BikeDisableState.InStorage,
            BikeDisableState.Missing,
            BikeDisableState.InWorkshop,
            BikeDisableState.ToWorkshop,
            BikeDisableState.RepairFinished,
            BikeDisableState.Moving,
            BikeDisableState.Scrapped
        ];
        if (excludedDisabledReasons.indexOf(bike.DisabledReason) > -1) {
            return false;
        }

        if (bike.DisabledReason == BikeDisableState.WithStreetTeam && !bike.InSession) {
            return false;
        }

        return !this.isWithinAnyStationRadius(bike, stations);
    }

    private static getDistanceInMeters(lat1: number, lon1: number, lat2: number, lon2: number): number {
        const earthRadiusMeters = 6371000;
        const toRad = (deg: number) => deg * Math.PI / 180;

        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return earthRadiusMeters * c;
    }

}
